/** ISO 文字列を日本時間の "YYYY-MM-DD HH:MM" に変換 */
export function formatJST(iso: string | undefined | null): string {
  if (!iso) return '-';
  // タイムゾーン情報がない場合は JST として扱う（サーバーが JST で記録しているため）
  const normalized = iso.endsWith('Z') || /[+-]\d{2}(:\d{2})?$/.test(iso) ? iso : iso + '+09:00';
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * ERP(カクテル)のカラム幅判定に使う Shift_JIS 換算のバイト数。
 * 半角(ASCII)=1バイト、それ以外(全角かな/漢字など)=2バイトで数える。
 * バックエンドの切り詰め(api/stores/oracle_store.py の _trunc)が
 * shift_jis エンコード後のバイト長で判定しているため、画面側も同じ尺度で数える。
 */
export function sjisByteLength(value: string): number {
  let bytes = 0;
  for (const ch of value) {
    bytes += ch.charCodeAt(0) <= 0x7f ? 1 : 2;
  }
  return bytes;
}

/** Shift_JIS 換算で maxBytes に収まるところまで切り詰める。 */
export function sjisTruncate(value: string, maxBytes: number): string {
  let bytes = 0;
  let out = '';
  for (const ch of value) {
    bytes += ch.charCodeAt(0) <= 0x7f ? 1 : 2;
    if (bytes > maxBytes) break;
    out += ch;
  }
  return out;
}
